<template>
    <Form @submit="createOrUpdate" :key="createMode">
        <div class="horse-color-form flex flex-column overflow-hidden gap-3">
            <CustomInputText name="name" :label="$t('message.horseColor.nameLong')" v-model="editedColor.name" noPlaceholder
                             class="w-10" required
                             :customErrorMessage="getRequiredMessage(editedColor.name)" />
            <CustomInputText name="abbreviation" :label="$t('message.horseColor.abbreviationLong')" noPlaceholder
                             v-model="editedColor.shortName" class="w-10" required
                             :customErrorMessage="getRequiredMessage(editedColor.shortName)" />
            <div class="horse-color-buttons flex align-self-center gap-4 mt-6">
                <CustomButton :label="$t('message.other.save')" type="submit" />
                <CustomButton v-if="createMode" :label="$t('message.other.cancel')" secondary
                              @click="hideForm" />
                <CustomButton v-else :disabled="createMode" secondary
                              :label="$t('message.other.delete')" @click="deleteEvent"/>
            </div>
        </div>
    </Form>
</template>

<script>
import _ from 'lodash';
import {Form} from "vee-validate";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { createOrUpdateHorseColor, deleteHorseColor } from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomSelectOneHorseBreed from "@/components/form/CustomSelectOneHorseBreed.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { ValidateUtils } from "@/utils/ValidateUtils";

export default {
    name: "HorseColorTable",
    components: {
        CustomCheckbox,
        CustomSelectOneHorseBreed,
        CustomInputText,
        CustomButton,
        Column,
        DataTable,
        Form,
    },

    props: {
        selectedColor: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            editedColor: {
                id: null,
                name: "",
                shortName: "",
            },
            createMode: true,
            showErrorMessages: false,
        };
    },

    emits: ["change-element", "createMode", "hideForm"],

    mounted() {
        this.$emit("createMode", this.createMode);
    },

    methods: {
        validateData() {
            let isCorrect = ValidateUtils.validateNotEmpty(this.editedColor, ["name", "shortName"]);
            this.showErrorMessages = !isCorrect;
            return isCorrect;
        },
        getRequiredMessage(value) {
            if (this.showErrorMessages && (value === null || value === "")) {
                return this.$t("message.validations.required");
            }
            return "";
        },
        notifyChange() {
            this.$emit("change-element");
            this.$toast.add({
                severity: "success",
                summary: this.$t('message.other.success'),
                detail: this.$t('message.other.dataSaved'),
                life: 3000,
            });
        },
        notifyDelete() {
            this.$emit("change-element");
            this.$toast.add({
                severity: "success",
                summary: this.$t('message.other.success'),
                detail: this.$t('message.other.elementDeleted'),
                life: 3000,
            });
        },
        notifyError(error) {
            const message = error.response?.data?.message || this.$t('unknownError');
            this.$toast.add({
                severity: "error",
                summary: this.$t('message.other.error'),
                detail: message,
                life: 5000,
            });
        },
        async createOrUpdate() {
            if (this.validateData()) {
                try {
                    await createOrUpdateHorseColor({ body: this.editedColor });
                    this.notifyChange();
                } catch (error) {
                    this.notifyError(error);
                }
            }
        },
        async deleteEvent() {
            try {
                await deleteHorseColor({ id: this.editedColor.id });
                this.notifyDelete();
                this.showErrorMessages = false;
            } catch (error) {
                this.notifyError(error);
            }
        },
        hideForm() {
            this.$emit("hideForm");
        },
    },

    watch: {
        selectedColor(newValue) {
            this.editedColor = _.cloneDeep(newValue);
            this.createMode = newValue.id === null || newValue.id === undefined || isNaN(newValue.id);
            this.$emit("createMode", this.createMode);
        },
    },
};
</script>

<style lang="less">
    .horse-color-form {
        .custom-input-text {
            padding-left: 230px;
            .custom-label {
                text-align: right;
                z-index: 999;
                position: absolute;
                transform: translateX(-100%);
                left: 220px;
            }
        }
        @media screen and (max-width: 650px) {
            align-items: end;
            .custom-input-text, .custom-select-one {
                padding-left: 100px;
                .custom-label {
                    left: 90px;
                }
            }
        }
    }
</style>
